import { map, Observable, take } from 'rxjs';
import { inject } from '@angular/core';
import { GamesService } from '@games/infra';
import { GameDetailsModel, mapGameDto } from '@core';
import { GameDto, GetGameByIdPathParams } from '@core-http';

export class GameDetailsQueryHandler {
  private readonly gamesService: GamesService = inject(GamesService);

  getGameDetails(gameId: string): Observable<GameDetailsModel> {
    const pathParams: GetGameByIdPathParams = { gameId };

    return this.gamesService.getOneGame(pathParams).pipe(
      take(1),
      map((dto: GameDto) => mapGameDto(dto))
    );
  }
}
